import { connect } from "react-redux"

import DummyWidget from "QuorumGrassroots/widgets/Dummy/index"

const mapStateToProps = (state, props) => ({})

const actions = {}

export default connect(mapStateToProps, actions)(DummyWidget)
